import React from 'react';
import { ICellRendererParams, ICellEditorParams } from 'ag-grid-community';
import Select from 'react-select/creatable';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover/popover';
import { i18n } from "../../lib/i18n";

interface SelectOption {
  value: string;
  label: string;
}

interface QualificationRendererProps {
  value: string[];
  qualifications: string[];
}

export const QualificationRenderer = (props: QualificationRendererProps) => {
  if (!props.value || !Array.isArray(props.value)) return <span></span>;
  
  return (
    <span className="resource-import-edit-grid__qualifications">
      {props.value.join(', ')}
    </span>
  );
};

interface QualificationEditorProps extends ICellEditorParams {
  value: string[];
  qualifications: string[];
  onValueChange(value: string[]): void;
  stopEditing(): void;
}

export const QualificationEditor = (props: QualificationEditorProps) => {
  const [selectedQualifications, setSelectedQualifications] = React.useState<string[]>(
    Array.isArray(props.value) ? props.value : []
  );

  // Convert qualifications to react-select options format
  const options = props.qualifications.map(qual => ({
    value: qual,
    label: qual
  }));

  // Convert current value to react-select format
  const value = selectedQualifications.map(v => ({ value: v, label: v }));

  const handleChange = (newValue: any) => {
    setSelectedQualifications(newValue.map((v: SelectOption) => v.value));
  };

  const handleCreate = (inputValue: string) => {
    setSelectedQualifications([...selectedQualifications, inputValue]);
  };

  return (
    <Popover defaultOpen onOpenChange={() => {
      props.onValueChange(selectedQualifications);
      props.stopEditing();
    }}>
      <PopoverTrigger>
        <QualificationRenderer 
          value={selectedQualifications} 
          qualifications={props.qualifications}
        />
      </PopoverTrigger>
      <PopoverContent className="bg-white p-4 min-w-[300px]">
        <div className="resource-import-edit-grid__qualifications-editor">
          <Select
            isMulti
            value={value}
            onChange={handleChange}
            options={options}
            className="w-full"
            classNamePrefix="react-select"
            placeholder={i18n.t('resource_import.select_or_type_qualification')}
            menuPosition="fixed"
            menuPortalTarget={document.body}
            onCreateOption={handleCreate}
            formatCreateLabel={(inputValue) => i18n.t('resource_import.add_value', { value: inputValue })}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999
              })
            }}
          />
          <div className="text-sm text-gray-500 mt-2">
            {i18n.t('resource_import.type_to_add_qualification')}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
